import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isMultiple", "isReadonly", "allowClear", "placeholder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { EnvironmentOutlined } from '@ant-design/icons';
import { Select, Space } from 'antd';
import { getZoneStore } from 'core/modules/zones/zone.store';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { sanitizeAll } from '../../utils/sanitize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Renders a select to select zones. */
export var ZoneSelect = function ZoneSelect(_ref) {
  var isMultiple = _ref.isMultiple,
      isReadonly = _ref.isReadonly,
      allowClear = _ref.allowClear,
      placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getZoneStore = getZoneStore(),
      zones = _getZoneStore.zones;

  return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, props), {}, {
    mode: isMultiple ? 'multiple' : undefined,
    allowClear: allowClear,
    bordered: !isReadonly,
    disabled: isReadonly,
    showSearch: true,
    filterOption: function filterOption(input, option) {
      return sanitizeAll(option.title).includes(sanitizeAll(input));
    },
    placeholder: isReadonly ? undefined : placeholder !== null && placeholder !== void 0 ? placeholder : t('form.task.zone.placeholder'),
    children: zones.map(function (zone) {
      return /*#__PURE__*/_jsx(Select.Option, {
        value: zone.id,
        title: zone.name,
        children: /*#__PURE__*/_jsxs(OptionContent, {
          size: "small",
          children: [/*#__PURE__*/_jsx("span", {
            className: "icon",
            children: /*#__PURE__*/_jsx(EnvironmentOutlined, {})
          }), /*#__PURE__*/_jsx("span", {
            className: "label",
            children: zone.name
          })]
        })
      }, zone.id);
    })
  }));
}; // Styles

var OptionContent = styled(Space).withConfig({
  displayName: "ZoneSelect__OptionContent",
  componentId: "sc-1wdhuoq-0"
})([""]);